// extracted by mini-css-extract-plugin
export default {"pillWrapper":"GkovclH","pill":"_3wY6tfM"};